import { create } from '@thoughtspot/logger';
import _ from 'lodash';
import { sanitizeCustomVisualPropsV2 } from '../../../utils/chart-settings/helpers';
import { generateVisPropWithColumnSettings, sanitizeCustomVisualProps, } from '../../../utils/form-builder.util';
import { getFlagsFromEventData } from '../native-chart-events/flag-events/utils';
import { validateUpadateVisualPropsEditorEventPayloadObject } from './util';
const logger = create('ts-to-chart > event-callbacks > update-visual-props-editor-definition');
const getUpdateVisualPropsEditorDefinitionEventProcessor = (props) => {
    const { chartModel, currentVisualPropEditorDefinition, updateVisualPropEditorDefinitionContext, persistedVisualPropKey, } = props;
    return {
        validateEventPayload: (eventData) => {
            try {
                validateUpadateVisualPropsEditorEventPayloadObject(eventData.payload?.visualPropEditorDefinition);
            }
            catch (err) {
                logger.warn(err);
                return {
                    isValid: false,
                    errors: [err.toString()],
                };
            }
            return {
                isValid: true,
            };
        },
        executeEvent: async (eventData) => {
            const initFlags = getFlagsFromEventData([
                'isChartSettingsV2Enabled',
            ]);
            const isChartSettingsV2Enabled = initFlags?.isChartSettingsV2Enabled?.flagValue ?? false;
            const updatedVisualPropEditorDefinition = eventData.payload
                ?.visualPropEditorDefinition;
            updateVisualPropEditorDefinitionContext({
                updatedVisualPropEditorDefinition,
                currentVisualPropEditorDefinition,
            });
            const defaultVisualPropsFromEditorDefinition = generateVisPropWithColumnSettings(updatedVisualPropEditorDefinition);
            let customVisualProps = _.isString(chartModel.customVisualProps)
                ? chartModel.customVisualProps
                : _.merge({}, defaultVisualPropsFromEditorDefinition, chartModel?.customVisualProps);
            if (!_.isString(customVisualProps)) {
                if (isChartSettingsV2Enabled) {
                    customVisualProps = sanitizeCustomVisualPropsV2(customVisualProps, updatedVisualPropEditorDefinition, persistedVisualPropKey);
                }
                else {
                    customVisualProps = sanitizeCustomVisualProps(customVisualProps, updatedVisualPropEditorDefinition, persistedVisualPropKey);
                }
            }
            return Promise.resolve(customVisualProps);
        },
    };
};
const testHooks = {
    getUpdateVisualPropsEditorDefinitionEventProcessor,
};
export { testHooks, getUpdateVisualPropsEditorDefinitionEventProcessor };
//# sourceMappingURL=index.js.map